module.exports = { "default": require("core-js/library/fn/reflect/get"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/get.js
// module id = 435
// module chunks = 36